import createLucideIcon from '../createLucideIcon';

const CircleOff = createLucideIcon('CircleOff', [
  ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
  [
    'path',
    {
      d: 'M8.4 2.7c1.2-.4 2.4-.7 3.7-.7 5.5 0 10 4.5 10 10 0 1.3-.2 2.5-.7 3.6',
      key: '1hk56q',
    },
  ],
  [
    'path',
    {
      d: 'M19.1 19.1C17.3 20.9 14.8 22 12 22 6.5 22 2 17.5 2 12c0-2.7 1.2-5.2 3-7',
      key: '1wj8vc',
    },
  ],
]);

export default CircleOff;
